import styled from 'styled-components';
import { BodyBoldL, BodyRegularL } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const HeadlineCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }: IThemeProvider) => `
    height: ${theme.layout.spacing.peta};
  `}
`;

export const Headline = styled(BodyRegularL)`
  width: 656px;
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `}
`;

export const HeadlineBold = styled(BodyBoldL)``;

export const ContentCont = styled.div`
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;

  [data-testid='input-label'] {
    ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.primary[100]};
    `}
  }
`;

export const SubmitButtonCont = styled.div`
  margin-top: 32px;
`;

export const ApiErrorCont = styled.div`
  width: 432px;
`;
